import React from 'react';
import Heading, { SIZE as HEADING_SIZE } from '../../Heading';
import { classes } from '../MarketingLayout.st.css.js';
import { isString } from '../../utils/StringUtils';
import { MARKETING_LAYOUT_TITLE } from '../dataHooks';
import { SIZES } from '../constants';
import PropTypes from 'prop-types';
const sizeToHeadingSize = {
    [SIZES.small]: HEADING_SIZE.MEDIUM,
    [SIZES.medium]: HEADING_SIZE.LARGE,
    [SIZES.large]: HEADING_SIZE.LARGE,
};
const Title = ({ children, size }) => (React.createElement("div", { className: classes.title }, isString(children) ? (size === SIZES.tiny ? (React.createElement("div", { "data-hook": MARKETING_LAYOUT_TITLE }, children)) : (React.createElement(Heading, { dataHook: MARKETING_LAYOUT_TITLE, size: sizeToHeadingSize[size] }, children))) : (React.createElement("div", { "data-hook": MARKETING_LAYOUT_TITLE }, children))));
Title.propTypes = {
    children: PropTypes.node,
    size: PropTypes.string,
};
export default Title;
//# sourceMappingURL=Title.js.map